import React from "react";
// import { react } from "../icons/react.png";
import nodejs from "../icons/nodejs.png";
import solidity from "../icons/solidity.png";
// import bootstrap from "../icons/bootstrap.png";
import cairo from "../icons/cairo.png";
import zig from "../icons/zig.png";
import typescript from "../icons/typescript.png";
import rust from "../icons/rust.png";
// import tailwind from "../icons/tailwind.png";
// import ethers from "../icons/ethers.png";
// import react from "../icons/react.png";
// import js from "../icons/js.png";
// import mongodb from "../icons/mongodb.png";
// import postgres from "../icons/postgres.png";
// import kafka from "../icons/kafka.png";
// import docker from "../icons/docker.png";

const About = () => {
  const techStacks = [
    {
      id: 1,
      title: "Rust",
      src: rust,
      style: "border-[#77472C] pb-8 ",
    },
    {
      id: 2,
      title: "Solidty",
      src: solidity,
      style: "border-[#68788E] pb-8",
    },
    {
      id: 3,
      title: "Cairo",
      src: cairo,
      style: "border-[#68788E] pb-8",
    },
    {
      id: 4,
      title: "Zig",
      src: zig,
      style: "border-[#68788E] pb-8",
    },
    {
      id: 3,
      title: "Node JS",
      src: nodejs,
      style: "border-[#6DA75D] pb-8",
    },
    {
      id: 5,
      title: "Typescript",
      src: typescript,
      style: "border-[#FFE43A]",
    },

    // {
    //   id: 6,
    //   title: "Ethers JS",
    //   src: ethers,
    //   style: "border-[#24339B] pb-12",
    // },
    // {
    //   id: 7,
    //   title: "MongoDB",
    //   src: mongodb,
    //   style: "border-[#6DA75D] pb-8 ",
    // },
  

    // {
    //   id: 10,
    //   title: "Docker",
    //   src: docker,
    //   style: "border-[#006BC0] pb-8 ",
    // },

  ];

  return (
    <div name="about" className="h-full  ">
      <div className="max-w-screen-lg mx-auto h-full flex flex-col justify-center items-center">
        <div className="pb-12">
          <h1 className="font-rubik font-normal text-4xl md:text-6xl pb-2 border-b-2 border-[#b03016] text-[#30BCED] ">
            About Me
          </h1>
        </div>
        <div className="px-4 text-center md:px-18">
          <p className="font-barlow md:text-4xl text-xl text-[#ebebeb]">
            Hi👋, <br /> I'm Varun Doshi. <br /> I specialize in creating{" "}
            <span style={{ color: "#FC5130" }}>fault-tolerant infrastrucutre</span>{" "}
            and <span style={{ color: "#FC5130" }}>highly scalable</span>{" "}
            solutions. <br />
            {/* Adept in writing{" "}
            <span style={{ color: "#FC5130" }}> clean & readable code</span>{" "}
            following industry standards. */}
             Currently building robust
            security engine to protect DeFi Protocols from
            <span style={{ color: "#FC5130" }}>
              {" "}
              Economic and Technical Attacks
            </span>. <br />
            {/*  Part time Smart Contract{" "}
            <span style={{ color: "#FC5130" }}>security researcher</span> saving
            projects from bugs and attacks! */}
            Building experise in Applied Cryptography with emphasis on <span style={{ color: "#FC5130" }}>Zero-Knowledge Proofs</span>.
          </p>
        </div>

        <div className="w-[80%]">
          <h1 className="text-[#ebebeb] font-rubik text-4xl md:text-5xl text-center mt-12">
            I <span className="text-[#30BCED]">Work</span> with...
          </h1>
          <div className="flex mt-6 gap-20 flex-wrap">
            {techStacks.map(({ id, title, src, style }) => (
              <div
                key={id}
                className={
                  " bg-[#131313] border-b-2 border-l-2 text-white text-center  rounded-md inline-block shadow-xl shadow-black " +
                  style
                }
              >
                <img
                  src={src}
                  alt=""
                  width={100}
                  className="md:m-4 p-4 md:p-2"
                />
                <p className="align-bottom text-lg font-rubik">{title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
